
import CalculatorStepper from '../components/LeadCalculator/CalculatorStepper';
export default {
  name: 'LeadCalculator',
  components: { CalculatorStepper }
};
